import { render, staticRenderFns } from "./FlexibleWeight.vue?vue&type=template&id=7437def4&scoped=true&"
import script from "./FlexibleWeight.vue?vue&type=script&lang=js&"
export * from "./FlexibleWeight.vue?vue&type=script&lang=js&"
import style0 from "./FlexibleWeight.vue?vue&type=style&index=0&id=7437def4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7437def4",
  null
  
)

export default component.exports